module.exports = __webpack_public_path__ + "img/Speaker=Alice Gao.152b4cf8.png";